import { useState } from 'react';
import '../scss/partner-search-input.scss';

interface Props {
  setFilterValue: React.Dispatch<React.SetStateAction<string>>;
}

const PartnerSearchInput: React.FC<Props> = ({ setFilterValue }) => {
  const [value, setValue] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    setFilterValue(e.target.value);
  };

  const clearValue = () => {
    setValue('');
    setFilterValue('');
  };

  return (
    <div className="partner-search-input-container">
      <input
        className="partner-search-input ms-1 mt-2 mb-3"
        type="text"
        placeholder="Pretraži brendove"
        value={value}
        onChange={handleChange}
      />
      {value.length > 0 && <div className="partner-search-input__x cursor-pointer" onClick={clearValue}></div>}
    </div>
  );
};

export default PartnerSearchInput;
